<template>
  <Layout header-class="header-left-align " nav-alignment="left">
    <PageBanner :image="require('@/assets/images/Newlandindpage/banner/contact.webp')"
      :light-image="require('@/assets/images/Newlandindpage/banner/contact-light.png')"
      :title="$t('header.contact')" :current="$t('header.contact')" />

    <!-- Start Contact Area  -->
    <div
      class="rwt-contact-area rn-section-gap"
      :class="{ '': userLogin === false, 'background-contact': userLogin === true }"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb--40">
            <SectionTitle
              text-align="center"
              :subtitle="$t('Contact.subtitle')"
              :title="$t('Contact.title')"
            />
          </div>
        </div>
        <div class="row row--15">
          <div class="col-lg-12">
            <div class="rn-contact-address mt_dec--30">
              <svg class="contact-icon-defs" aria-hidden="true" width="0" height="0">
                <defs>
                  <linearGradient id="contact-icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#9949d4" />
                    <stop offset="100%" stop-color="#ff4454" />
                  </linearGradient>
                </defs>
              </svg>
              <div class="row">
                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address" style="height: 90%">
                    <div class="icon">
                      <Icon name="headphones" :size="40" />
                    </div>
                    <div class="inner">
                      <h4 class="LexenBold">{{ $t('Contact.phoneTitle') }}</h4>
                      <p class="LexenSemiBold">
                        <a href="tel:+6626029518">+66 2602 9518</a>
                      </p>
                      <p class="LexenSemiBold"><a href="tel:+66837778822">+66 8377 78822</a></p>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address" style="height: 90%">
                    <div class="icon">
                      <Icon name="mail" :size="40" />
                    </div>
                    <div class="inner">
                      <h4 class="LexenBold">{{ $t('Contact.emailTitle') }}</h4>
                      <p class="LexenSemiBold">
                        <a href="mailto:evangelist@gridwhiz.io">evangelist@gridwhiz.io</a>
                      </p>
                      <!-- <p>
                        <a href="mailto:evangelist@gridwhiz.io">evangelist@gridwhiz.io</a>
                      </p> -->
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 col-12">
                  <div class="rn-address" style="height: 90%">
                    <div class="icon">
                      <Icon name="map-pin" :size="40" />
                    </div>
                    <div class="inner">
                      <h4 class="LexenBold">{{ $t('Contact.locationTitle') }}</h4>
                      <p class="LexenSemiBold">
                        184/185 Forum Tower 28th FL. Rachadapisek Rd. Huaikhwang, Bangkok 10310
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt--40">
          <div class="col-lg-7">
            <ContactForm />
          </div>
          <div class="col-lg-5 mt_md--30 mt_sm--30">
            <GoogleMap />
          </div>
        </div>
      </div>
    </div>
    <!-- End Contact Area  -->
  </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import PageBanner from '../components/common/PageBanner'
import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
import Icon from '../components/icon/Icon'
import GoogleMap from '../components/elements/contact/GoogleMap'
import ContactForm from '../components/elements/contact/ContactForm'

export default {
  name: 'ContactPage',
  components: {
    ContactForm,
    GoogleMap,
    Icon,
    SectionTitle,
    PageBanner,
    Layout
  },
  computed: {
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>
<style>
.background-contact {
  background-image: url(../assets/images/Newlandindpage/lightmode/bg-contact.png);
  background-size: cover;
  background-position: -0% 0%;
  /* background-repeat: no-repeat; */
  background-position: center;
  z-index: 2;
  width: 100%;
  height: 100%;
}
</style>
